export default __webpack_public_path__ + "static/media/central.892b90c4.png";